import $ from 'jquery';

$(document).ready(function() {
	let text = '';
	$(document).on('click', '.js-modal-review-select', function(e) {
		if (!((e.target).closest('.js-modal-review-inner-list'))) {
            $(this).toggleClass('active');
	    	if ($(this).hasClass('active')) {
	    		$(this).find('.js-modal-review-inner-list').slideDown();
	    	} else {
	    		$(this).find('.js-modal-review-inner-list').slideUp();
	    	}
    	}
	});
	$(document).on('click', '.js-modal-review-inner-item', function() {
		text = $(this).text();
		$(this).parents('.js-modal-review-select').find('span').text(text);
		$(this).parents('.js-modal-review-select').removeClass('active');
		$(this).parents('.js-modal-review-inner-list').slideUp();
	});
	$('body').on('click', function(e) {
		if (!((e.target).closest('.js-modal-review-inner-list')) && 
			!((e.target).closest('.js-modal-review-select'))) {
			$('.js-modal-review-select').removeClass('active')
			$('.js-modal-review-inner-list').slideUp();
		}
	});
});


// WEBPACK FOOTER //
// ./src/js/pages/reviews/modal-review-select.js